"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthStatus = exports.ProxyApiHeader = exports.SuggestObjectAction = exports.SuggestAction = exports.ChangeStatus = exports.SupportedPosition = exports.DescriptionCategoryType = exports.OrderPriceCalcType = exports.OrderStatus = exports.AddressObjectType = exports.AddressType = exports.CancelState = exports.CostBreakdownName = exports.PaymentMethodType = void 0;
var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["CASH"] = "cash";
    PaymentMethodType["CARD"] = "card";
    PaymentMethodType["CORP"] = "corp";
    PaymentMethodType["APPLE_PAY"] = "applepay";
    PaymentMethodType["GOOGLE_PAY"] = "googlepay";
    PaymentMethodType["PERSONAL_WALLET"] = "personal_wallet";
    PaymentMethodType["COOP_ACCOUNT"] = "coop_account";
})(PaymentMethodType = exports.PaymentMethodType || (exports.PaymentMethodType = {}));
var CostBreakdownName;
(function (CostBreakdownName) {
    CostBreakdownName["COST"] = "cost";
    CostBreakdownName["COST_WITHOUT_DISCOUNT"] = "cost_without_discount";
    CostBreakdownName["TOTAL_DISCOUNT"] = "total_discount";
    CostBreakdownName["DISCOUNT"] = "discount";
    CostBreakdownName["BASE_DISCOUNT"] = "base_discount";
    CostBreakdownName["CALL_CENTER_DISCOUNT"] = "call_center_discount";
    CostBreakdownName["YA_PLUS_DISCOUNT"] = "ya_plus_discount";
})(CostBreakdownName = exports.CostBreakdownName || (exports.CostBreakdownName = {}));
var CancelState;
(function (CancelState) {
    CancelState["FREE"] = "free";
    CancelState["MINIMAL"] = "minimal";
    CancelState["PAID"] = "paid";
})(CancelState = exports.CancelState || (exports.CancelState = {}));
var AddressType;
(function (AddressType) {
    AddressType["ADDRESS"] = "address";
    AddressType["ORGANIZATION"] = "organization";
})(AddressType = exports.AddressType || (exports.AddressType = {}));
var AddressObjectType;
(function (AddressObjectType) {
    AddressObjectType["AIRPORT"] = "\u0430\u044D\u0440\u043E\u043F\u043E\u0440\u0442";
    AddressObjectType["ORGANIZATION"] = "\u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F";
    AddressObjectType["OTHER"] = "\u0434\u0440\u0443\u0433\u043E\u0435";
})(AddressObjectType = exports.AddressObjectType || (exports.AddressObjectType = {}));
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["DRIVING"] = "driving";
    OrderStatus["WAITING"] = "waiting";
    OrderStatus["CALLING"] = "calling";
    OrderStatus["TRANSPORTING"] = "transporting";
    OrderStatus["COMPLETE"] = "complete";
    OrderStatus["FAILED"] = "failed";
    OrderStatus["CANCELLED"] = "cancelled";
    OrderStatus["EXPIRED"] = "expired";
    OrderStatus["SEARCH"] = "search";
    OrderStatus["DRAFT"] = "draft";
    OrderStatus["SCHEDULING"] = "scheduling";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
var OrderPriceCalcType;
(function (OrderPriceCalcType) {
    OrderPriceCalcType["TAXIMETER_OBLIGED"] = "taximeter_obliged";
    OrderPriceCalcType["TAXIMETER_PERMANENT"] = "taximeter_permanent";
    OrderPriceCalcType["FIXED"] = "fixed";
})(OrderPriceCalcType = exports.OrderPriceCalcType || (exports.OrderPriceCalcType = {}));
var DescriptionCategoryType;
(function (DescriptionCategoryType) {
    DescriptionCategoryType["APPLICATION"] = "application";
    DescriptionCategoryType["CALL_CENTER"] = "call_center";
    DescriptionCategoryType["CATEGORY_TYPE"] = "category_type";
})(DescriptionCategoryType = exports.DescriptionCategoryType || (exports.DescriptionCategoryType = {}));
var SupportedPosition;
(function (SupportedPosition) {
    SupportedPosition["ZONES"] = "zones";
    SupportedPosition["PICKUP_POINTS"] = "pickup_points";
})(SupportedPosition = exports.SupportedPosition || (exports.SupportedPosition = {}));
var ChangeStatus;
(function (ChangeStatus) {
    ChangeStatus["PENDING"] = "pending";
    ChangeStatus["SUCCESS"] = "success";
    ChangeStatus["FAILED"] = "failed";
})(ChangeStatus = exports.ChangeStatus || (exports.ChangeStatus = {}));
var SuggestAction;
(function (SuggestAction) {
    SuggestAction["CONFIRM"] = "confirm";
    SuggestAction["PIN_DROP"] = "pin_drop";
    SuggestAction["SEARCH"] = "search";
    SuggestAction["USER_INPUT"] = "user_input";
    SuggestAction["USER_SELECT"] = "user_select";
    SuggestAction["ZERO_SUGGEST"] = "zero_suggest";
    SuggestAction["FINALIZE"] = "finalize";
    SuggestAction["TARIFF_CHANGE"] = "tariff_change";
    SuggestAction["REDIRECT"] = "redirect";
    SuggestAction["GEO_MAGNET"] = "geomagnet";
})(SuggestAction = exports.SuggestAction || (exports.SuggestAction = {}));
var SuggestObjectAction;
(function (SuggestObjectAction) {
    SuggestObjectAction["SUBSTITUTE"] = "substitute";
    SuggestObjectAction["SEARCH"] = "search";
})(SuggestObjectAction = exports.SuggestObjectAction || (exports.SuggestObjectAction = {}));
var ProxyApiHeader;
(function (ProxyApiHeader) {
    ProxyApiHeader["USER_ID"] = "X-YaTaxi-UserId";
    ProxyApiHeader["TOKEN"] = "X-CSRF-Token";
})(ProxyApiHeader = exports.ProxyApiHeader || (exports.ProxyApiHeader = {}));
var AuthStatus;
(function (AuthStatus) {
    AuthStatus["AUTHORIZED"] = "authorized";
    AuthStatus["PHONE_CONFIRMATION_REQUIRED"] = "phone_confirmation_required";
    AuthStatus["UNAUTHORIZED"] = "unauthorized";
})(AuthStatus = exports.AuthStatus || (exports.AuthStatus = {}));
